"use strict";

const { default: Swal } = require("sweetalert2");
const config = require('../../../../../config/locales_json/packs/private/admin/oferts_top.json');
const language = $('body').data("language");

$(document).ready(function() {
    var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');

    // Al hacer click en algun menu del header
    $("#kt_header .header-top").on("click", ".nav-link", function(){
        // Se revisa si esta el attributo data-target que indica que es un menu con tab
        var isTab = $(this).attr("data-target") 
        // Si es un link del tipo tab
        if(typeof isTab !== 'undefined'){
            // Le quita la clase que hace que quede oculto
            $("#kt_header .header-bottom").removeClass("hidden-lg")
        }
    })

    /* * * * * * * * * * * * * * * * * * *
    *
    *   TABLA DRAG AND DROP
    *
    */

    // Tabla donde se ejecuta el drag and drop
    var topTable = $("#ofert_top_table");
    // Inicializa la tabla con el drag and drop
    topTable.tableDnD({
        dragHandle: ".dragHandle",
        onDrop: function (table, row) {
            // Muestra un cargando
            KTApp.blockPage({
                overlayColor: '#000000',
                opacity: 0.3,
                state: 'primary',
                message: getTranslationValue(config, [language, "topTable", "KTApp_blockPage_message"], 'Ordenando...')
            });

            // Se obtienen las filas
            var rows = table.tBodies[0].rows;
            // Se almacenan en un array el orden de las ofertas
            var arrayOrderOferts = []
            // Se recorre cada fila
            for (var i = 0; i < rows.length; i++) {
                arrayOrderOferts.push(rows[i].id)
            }
            
            // Consulta ajax
            $.ajax({
                type: "POST",
                url: "/admin/ofertas/top/move",
                dataType: 'json',
                data: {
                    array_order_oferts: arrayOrderOferts,
                    authenticity_token: AUTH_TOKEN
                }
            }).done(function(response, textStatus, jqXHR) {
                // Actualiza los numeros de orden en la tabla
                for (var i = 0; i < rows.length; i++) {
                    $(rows[i]).find(".dragHandle").find("div").text(i+1)
                }

                // Quita el cargando
                KTApp.unblockPage();

            }).fail(function(jqXHR, textStatus, errorThrown) {
                // Quita el cargando
                KTApp.unblockPage();
                // Muestra alerta indicando que hay un error
                Swal.fire({
                    text: getTranslationValue(config, [language, "topTable", "fail_Swalfire_text"], 'Lo sentimos!, Hubo un problema y no se pudo cambiar de orden. Por favor inténtalo mas tarde.'),
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: getTranslationValue(config, [language, "topTable", "fail_Swalfire_confirmButtonText"], 'Aceptar'),
                    customClass: {
                        confirmButton: "btn btn-fj-purple"
                    }
                }).then(function () {
                    // Actualiza la visra
                    location.reload()
                });
            });
        }
    });

    /* * * * * * * * * * * * * * * * * * *
    *
    *   AGREGAR TOP
    *
    */
    // Al apretar el boton Agregar oferta
    $("#add_ofert_top").on("click", function(e){
        e.preventDefault()
        // Activa el modal
        $("#add_ofert_top_modal").modal('toggle')
    })

    // Se inicializa el selectize para cliente
    var $selectClient = $("#add_ofert_top_modal #ofert_top_client").selectize({
		create: false
    })

    // Se inicializa el selectize para oferta
    var $selectOfert = $("#add_ofert_top_modal #ofert_top_ofert").selectize({
		create: false
    })

    // Al escoger un cliente
    $("#add_ofert_top_modal #ofert_top_client").on("change", function(){
        // Muestra un cargando
        KTApp.blockPage({
            overlayColor: '#000000',
            opacity: 0.3,
            state: 'primary',
            message: getTranslationValue(config, [language, "on_change_ofert_top_modal", "KTApp_blockPage_message"], 'Buscando Ofertas...')
        });
        
        // Declaramos internamente el selectize
        var selectize = $selectOfert[0].selectize
        selectize.clear(true)
        selectize.clearOptions(true)

        // Asignamos clientID
        var clientID = $(this).val()
        // Consulta ajax para obtener las ofertas del cliente
        $.ajax({
            type: "GET",
            url: "/admin/ofertas/"+clientID+"/get_oferts",
            dataType: 'json'
        }).done(function(response, textStatus, jqXHR) {
            // Quita el cargando
            KTApp.unblockPage();
            // Limpia el selector de oferta
            $("#add_ofert_top_modal #ofert_top_ofert").html('')
            // Agrega al selector de oferta la opcion de "Seleccione una oferta"
            const optionValue = getTranslationValue(config, [language, "on_change_ofert_top_modal", "ajax_done_function", "option_value"], 'Seleccione una oferta')
            $("#add_ofert_top_modal #ofert_top_ofert").append('<option value="">'+optionValue+'</option>')
            // Asigna la variable data
            var data = response.data
            // Si no hay ofertas
            if(data.length == 0){
                // Agrega la clase disabled para no permitir el uso del selector
                $("#add_ofert_top_modal #ofert_top_ofert").addClass("disabled")
                $("#cont_form_ofert_top_ofert .selectize-control").addClass("disabled")
                // Muestra alerta indicando que no hay ofertas
                const swalfireText = getTranslationValue(config, [language, "on_change_ofert_top_modal", "ajax_done_function", "if_data_length_Swalfire_text"], 'Seleccione una oferta');
                const swalfireConfirmButtonText = getTranslationValue(config, [language, "on_change_ofert_top_modal", "ajax_done_function", "if_data_length_Swalfire_confirmButtonText"], 'Aceptar');

                Swal.fire({
                    text: swalfireText,
                    icon: "warning",
                    buttonsStyling: false,
                    confirmButtonText: swalfireConfirmButtonText,
                    customClass: {
                        confirmButton: "btn btn-fj-purple"
                    }
                });
            // Si hay ofertas
            } else {
                // Se quita la clase disabled para poder utilizar el selector
                $("#cont_form_ofert_top_ofert #ofert_top_ofert").removeClass("disabled")
                $("#cont_form_ofert_top_ofert .selectize-control").removeClass("disabled")
                // Recorre cada oferta
                for (var i = 0; i < data.length; i++) {
                    selectize.addOption({value:data[i].id,text:data[i].title});
                }
            }

        }).fail(function(jqXHR, textStatus, errorThrown) {
            // Quita el cargando
            KTApp.unblockPage();
            // Muestra alerta indicando que hay un error
            const swalfireText = getTranslationValue(config, [language, "on_change_ofert_top_modal", "ajax_fail_function", "Swalfire_text"], 'Lo sentimos!, Hubo un problema y no se pudo encontrar ofertas. Por favor inténtalo mas tarde.');
            const swalfireConfirmButtonText = getTranslationValue(config, [language, "on_change_ofert_top_modal", "ajax_done_function", "Swalfire_confirmButtonText"], 'Aceptar');

            Swal.fire({
                text: swalfireText,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: swalfireConfirmButtonText,
                customClass: {
                    confirmButton: "btn btn-fj-purple"
                }
            });
        });
    })

    // Al enviar el formulario
    $("#add_ofert_top_modal #send_modal_add_top_form").on("click", function(e){
        e.preventDefault()
        // Estado inicial del error
        var error = 0;
        // Obtiene los valores de los selectores
        var clientID = $("#add_ofert_top_modal #ofert_top_client")
        var ofertID = $("#add_ofert_top_modal #ofert_top_ofert")
        
        // Comienzan las validaciones
        
        // Si el valor del selector de cliente esta vacio
        if(clientID.val() == ""){
            // Le asigna un error al contador y le agrega la clase error al selectize
            error++
            $("#cont_form_ofert_top_client .selectize-control").addClass("error")
        // Si viene un valor en el selector de cliente
        } else {
            // Quita la clase error al selectize
            $("#cont_form_ofert_top_client .selectize-control").removeClass("error")
        }

        // Si el valor del selector de oferta esta vacio
        if(ofertID.val() == ""){
            // Le asigna un error al contador y le agrega la clase error al selectize
            error++
            $("#cont_form_ofert_top_ofert .selectize-control").addClass("error")
        } else {
             // Quita la clase error al selectize
            $("#cont_form_ofert_top_ofert .selectize-control").removeClass("error")
        }

        // Si no hay errores
        if(!error){
            // Muestra un cargando
            const message = getTranslationValue(config, [language, "on_click_send_modal", "if_not_error_message"], 'Agregando...');

            KTApp.blockPage({
                overlayColor: '#000000',
                opacity: 0.3,
                state: 'primary',
                message: message
            });
            
            // Bloquea el formulario y el modal para que no pueda cerrarlo mientras se procesa la información
            $("#add_ofert_top_modal #form_modal_add_ofert_top").addClass("disabled")
            $("#add_ofert_top_modal #close_add_ofert_top_modal").addClass("disabled")
            $("#add_ofert_top_modal #form_modal_add_ofert_top").submit()
        // Si hay errores
        } else {
            // Muestra una alerta
            const swalfireText = getTranslationValue(config, [language, "on_click_send_modal", "else_Swalfire_text"], 'Debes completar los campos obligatorios.');
            const swalfireConfirmButtonText = getTranslationValue(config, [language, "on_click_send_modal", "else_Swalfire_confirmButtonText"], 'Aceptar');

            Swal.fire({
                text: swalfireText,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: swalfireConfirmButtonText,
                customClass: {
                    confirmButton: "btn btn-fj-purple"
                }
            });
        }
    })

    // Limpieza de selects al cerrar o cancelar el modal
    $("#add_ofert_top_modal #close_add_ofert_top_modal").on("click", function(e){
        clearModalSelect()
    })

    $("#add_ofert_top_modal #cancel_modal_add_top_form").on("click", function(e){
        clearModalSelect()
    })

    // Metodo que limpia los selectize del modal
    function clearModalSelect(){
        // Declaramos internamente el selectize para cliente
        var selectizeClient = $selectClient[0].selectize
        // Limpia el input y selector
        selectizeClient.clear(true)
        //selectizeClient.clearOptions(true)

        // Declaramos internamente el selectize para oferta
        var selectizeOfert = $selectOfert[0].selectize
        // Limpia el input y selector
        selectizeOfert.clear(true)
        selectizeOfert.clearOptions(true)

        // Remueve la clase error
        $("#cont_form_ofert_top_client .selectize-control").removeClass("error")
        $("#cont_form_ofert_top_ofert .selectize-control").removeClass("error")

        // Agrega la clase disabled para no permitir el uso del selector
        $("#add_ofert_top_modal #ofert_top_ofert").addClass("disabled")
        $("#cont_form_ofert_top_ofert .selectize-control").addClass("disabled")
    }

    /* * * * * * * * * * * * * * * * * * *
    *
    *   ELIMINAR DEL LISTADO
    *
    */

    $("#ofert_top_table").on("click", ".delete-top-ofert", function(e){
        e.preventDefault()

        var $this = $(this)

        const swalfireText = getTranslationValue(config, [language, "on_click_ofert_top_table", "Swalfire_text"], '¿Desea quitar de la lista ésta oferta?');
        const swalfireConfirmButtonText = getTranslationValue(config, [language, "on_click_ofert_top_table", "Swalfire_confirmButtonText"], 'Eliminar');
        const swalfireCancelButtonText = getTranslationValue(config, [language, "on_click_ofert_top_table", "Swalfire_cancelButtonText"], 'Cancelar');

        // Muestra alerta para confirmar accion
        Swal.fire({
            text: swalfireText,
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: swalfireConfirmButtonText,
            showCancelButton: true,
            cancelButtonText: swalfireCancelButtonText,
            customClass: {
                confirmButton: "btn btn-danger",
                cancelButton: "btn btn-light"
            }
        }).then(function (result) {
            if(result.isConfirmed){
                // Muestra un cargando
                const message = getTranslationValue(config, [language, "on_click_ofert_top_table", "then_KTApp_blockPage_message"], 'Eliminando de la lista...');

                KTApp.blockPage({
                    overlayColor: '#000000',
                    opacity: 0.3,
                    state: 'primary',
                    message: message
                });

                $this.parent().submit()
            }
        });
    })

    // Se inicializa el selectize para cliente
    var $selectClient = $("select#ofert_country_id").selectize({
		create: false
    })

});

window.initMap = initMap;
function initMap() {
    const coord = { lat: Number(document.getElementById("map").dataset.lat) || -33.459229, lng: Number(document.getElementById("map").dataset.lon) || -70.645348 }
    //console.log({coord});
    const map = new google.maps.Map(document.getElementById("map"), {
      center: coord,
      zoom: 14,
    });
    
    // const card = document.getElementById("pac-card");
    const input = document.getElementById("ofert_address");
    const inputOfertLongitude = document.getElementById("ofert_longitude");
    const inputOfertLatitude = document.getElementById("ofert_latitude");
    // const biasInputElement = document.getElementById("use-location-bias");
    // const strictBoundsInputElement = document.getElementById("use-strict-bounds");
    const options = {
      fields: ["address_components", "geometry", "icon", "name"],
      origin: map.getCenter(),
      strictBounds: false
    };
    // map.controls[google.maps.ControlPosition.TOP_RIGHT].push(card);

    const autocomplete = new google.maps.places.Autocomplete(input, options);
    // Bind the map's bounds (viewport) property to the autocomplete object,
    // so that the autocomplete requests use the current map bounds for the
    // bounds option in the request.
    autocomplete.bindTo("bounds", map);
    
    const marker = new google.maps.Marker({
      map,
      anchorPoint: new google.maps.Point(0, -29),
    });
    autocomplete.addListener("place_changed", () => {
      
      marker.setVisible(false);
      const place = autocomplete.getPlace();
  
      if (!place.geometry || !place.geometry.location) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        window.alert("No details available for input: '" + place.name + "'");
        return;
      }else{
        inputOfertLongitude.value=place.geometry.location.lng();
        inputOfertLatitude.value=place.geometry.location.lat();
      }
  
      // If the place has a geometry, then present it on a map.
      if (place.geometry.viewport) {
        map.fitBounds(place.geometry.viewport);
      } else {
        map.setCenter(place.geometry.location);
        map.setZoom(17);
      }
      marker.setPosition(place.geometry.location);
      marker.setVisible(true);
      //console.log({ place });
    });
  
   
}

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}

	return currentTranslation;
}

